/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteJobYieldModal_jobYield$ref: FragmentReference;
declare export opaque type DeleteJobYieldModal_jobYield$fragmentType: DeleteJobYieldModal_jobYield$ref;
export type DeleteJobYieldModal_jobYield = {|
  +id: string,
  +item: {|
    +id: string,
    +name: string,
  |},
  +$refType: DeleteJobYieldModal_jobYield$ref,
|};
export type DeleteJobYieldModal_jobYield$data = DeleteJobYieldModal_jobYield;
export type DeleteJobYieldModal_jobYield$key = {
  +$data?: DeleteJobYieldModal_jobYield$data,
  +$fragmentRefs: DeleteJobYieldModal_jobYield$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "DeleteJobYieldModal_jobYield",
  "type": "JobYield",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": null,
      "concreteType": "Item",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fdb6d35c71befa6f952f1ed6395a241a';
module.exports = node;
